import { imageField } from 'molecules/Image/config';
import { videoFields } from 'molecules/Video/config';

import type { Input } from '@builder.io/sdk';

export const pageHeaderHeroFields = [
  {
    name: 'backgroundColor',
    type: 'string',
    enum: ['white', 'grey'],
    defaultValue: 'white',
  },
  {
    name: 'removePadding',
    type: 'boolean',
    defaultValue: false,
  },
  {
    name: 'eyebrow',
    type: 'string',
  },
  {
    name: 'subhead',
    type: 'string',
  },
  {
    name: 'contents',
    type: 'list',
    subFields: [
      {
        name: 'body',
        type: 'richText',
      },
      {
        name: 'ctas',
        type: 'list',
        subFields: [
          {
            name: 'label',
            type: 'string',
          },
          {
            name: 'link',
            type: 'string',
          },
          {
            name: 'type',
            type: 'string',
            enum: ['arrow', 'button'],
          },
          {
            name: 'removeBottomMargin',
            type: 'boolean',
            defaultValue: false,
          },
        ],
      },
      ...videoFields,
    ],
  },
  imageField('borderBottomImage'),
] as const satisfies DeepReadonly<Input[]>;

const pageHeaderHeroConfig = {
  name: 'Header Hero',
  inputs: pageHeaderHeroFields,
};

export type PageHeaderHeroProps = GenerateBuilder<typeof pageHeaderHeroFields>;

export default pageHeaderHeroConfig;
